import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toList3oc4f57w5sjau as toList } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collection.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import {
  first58ocm7j58k3q as first,
  drop3na99dw9feawf as drop,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Builder32honxq3tatym as Builder } from '../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *singleSuccessOrException($this, flow, $completion) {
  var responses = yield* toList(flow, VOID, $completion);
  // Inline function 'kotlin.collections.partition' call
  var first_0 = ArrayList().p2();
  var second = ArrayList().p2();
  var _iterator__ex2g4s = responses.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!(element.b44_1 == null)) {
      first_0.i2(element);
    } else {
      second.i2(element);
    }
  }
  var _destruct__k2r9zo = new (Pair())(first_0, second);
  var exceptionResponses = _destruct__k2r9zo.we();
  var successResponses = _destruct__k2r9zo.xe();
  var tmp;
  switch (successResponses.q2()) {
    case 0:
      var tmp_0;
      switch (exceptionResponses.q2()) {
        case 0:
          throw DefaultApolloException().l44('The operation did not emit any item, check your interceptor chain');
        case 1:
          tmp_0 = first(exceptionResponses);
          break;
        default:
          var first_1 = first(exceptionResponses);
          var tmp_1 = first_1.e43();
          var tmp0 = drop(exceptionResponses, 1);
          // Inline function 'kotlin.collections.fold' call

          var accumulator = ensureNotNull(first_1.b44_1);
          var _iterator__ex2g4s_0 = tmp0.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var element_0 = _iterator__ex2g4s_0.r1();
            // Inline function 'kotlin.also' call
            var this_0 = accumulator;
            addSuppressed(this_0, ensureNotNull(element_0.b44_1));
            accumulator = this_0;
          }

          var tmp$ret$2 = accumulator;
          tmp_0 = tmp_1.u43(tmp$ret$2).y36();
          break;
      }

      tmp = tmp_0;
      break;
    case 1:
      tmp = first(successResponses);
      break;
    default:
      throw DefaultApolloException().l44('The operation returned multiple items, use .toFlow() instead of .execute()');
  }
  return tmp;
}
var ApolloCallClass;
function ApolloCall() {
  if (ApolloCallClass === VOID) {
    class $ {
      static g61(apolloClient, requestBuilder) {
        var $this = createThis(this);
        $this.e61_1 = apolloClient;
        $this.f61_1 = requestBuilder;
        return $this;
      }
      static h61(apolloClient, operation) {
        return this.g61(apolloClient, new (Builder())(operation));
      }
      j42(name, value) {
        // Inline function 'kotlin.apply' call
        this.f61_1.j42(name, value);
        return this;
      }
      i61() {
        return this.e61_1.e62(this.f61_1.y36(), false);
      }
      *f62($completion) {
        return yield* /*#__NOINLINE__*/singleSuccessOrException(this, this.i61(), $completion);
      }
    }
    initMetadataForClass($, 'ApolloCall', VOID, VOID, VOID, [0, 1]);
    ApolloCallClass = $;
  }
  return ApolloCallClass;
}
//region block: exports
export {
  ApolloCall as ApolloCallpwdxdy18rzuy,
};
//endregion

//# sourceMappingURL=ApolloCall.mjs.map
